import { useEffect, useRef } from 'react';
import { useFollowingUser } from './useFollowingUser';
import type { Rect } from '@view-model/models/common/basic/Rect';

type Props = {
  setClientViewBox: (viewBox: Rect) => void;
};

/**
 * フォロー中のユーザーのビューポートに継続的に同期するフック
 */
export const useFollowingViewportSync = ({ setClientViewBox }: Props): void => {
  const { followingViewer } = useFollowingUser();
  const prevRectRef = useRef<Rect | null>(null);

  useEffect(() => {
    if (!followingViewer) {
      prevRectRef.current = null;
      return;
    }

    const currentRect = followingViewer.rect;

    // currentRect が null の場合は何もしない
    if (!currentRect) {
      prevRectRef.current = null;
      return;
    }

    // 初回または rect が変更された場合のみ同期
    if (prevRectRef.current && prevRectRef.current.isEqual(currentRect)) {
      return;
    }

    prevRectRef.current = currentRect;

    setClientViewBox(currentRect);
  }, [followingViewer, setClientViewBox]);
};
